import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, ResponsiveContainer } from 'recharts';

const data = [
  { name: 'Streamlined Checkout Process', npsImpact: 2 },
  { name: '24/7 Customer Support', npsImpact: 2 },
  { name: 'Improved Product Search Functionality', npsImpact: 1 },
  { name: 'Extended Product Warranty', npsImpact: 1 },
  { name: 'Faster Shipping Options', npsImpact: 3 },
  { name: 'Loyalty Reward Program', npsImpact: 2 }
];

// A function to render custom labels on each bar for more creativity
const renderCustomLabel = (props) => {
    const { x, y, width, value } = props;
    return <text x={x + width + 5} y={y} fill="#666" textAnchor="start" dominantBaseline="middle">
        {`+${value} NPS`}
    </text>;
};

const NPSImprovementSuggestionsChart = () => (
  <ResponsiveContainer width="100%" height={400}>
    <BarChart
      layout="vertical"
      data={data}
      margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis type="number" />
      <YAxis dataKey="name" type="category" width={150} />
      <Tooltip />

      <Bar dataKey="npsImpact" fill="#82ca9d" >
        <LabelList dataKey="npsImpact" position="insideRight" content={renderCustomLabel} />
      </Bar>
    </BarChart>
  </ResponsiveContainer>
);

export default NPSImprovementSuggestionsChart;